$(document).ready(function(){
  $('.slick-slider2').slick({
    infinite: true,
    slidesToShow: 4,  // Show 4 slides by default
    slidesToScroll: 1,  // Scroll 1 slide at a time
    autoplay: false,
    autoplaySpeed: 3000,
    dots: false,  // Add pagination dots
    arrows: true,  // Enable navigation arrows
    prevArrow:'<button class="prev-arrow"><</button>',
    nextArrow:'<button class="next-arrow">></button>',
    responsive: [
      {
        breakpoint: 1024,  // Below 1024px screen width
        settings: {
          slidesToShow: 3,  // Show 3 slides
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,  // Below 768px screen width
        settings: {
          slidesToShow: 2,  // Show 2 slides
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 480,  // Below 480px screen width
        settings: {
          slidesToShow: 1,  // Show 1 slide
          slidesToScroll: 1
        }
      }
    ]
  });
});

document.addEventListener("DOMContentLoaded", function () {
    // Select all <li> elements with the class 'slick-slide'
    document.querySelectorAll("li.slick-slide").forEach(function (liElement) {
        // Find the .tag_title <p> inside each slick-slide <li>
        let titleElement = liElement.querySelector(".tag_title p");

        if (titleElement) {
            let text = titleElement.textContent.trim();
            let words = text.split(" ");

            // Trim the title if it has more than 10 words
            if (words.length > 10) {
                titleElement.textContent = words.slice(0, 10).join(" ") + "...";
            }
        }
    });
});
